[
  "#FF6A00",
  "#A8E063",
  "#00653F",
  "#00B3B3",
  "#0081FF",
  "#592D8D",
  "#750839"
]
